import { call, put, select, takeEvery } from 'redux-saga/effects';

import { Action, RequestWithEntity, Types } from '../ducks';
import { EndpointCreator, EntityWithId, IClient, IUpdateActions } from '../interfaces';
import { getEndpoint } from './endpoint';

export function* update<T>(
  client: IClient<T>,
  endpointCreator: EndpointCreator,
  actions: IUpdateActions<T>,
  id: string,
  entity: T,
  params?: { [key: string]: string },
) {
  yield put(actions.startUpdate(id));

  const endpoint: string = yield select(getEndpoint, endpointCreator, params);
  if (!endpoint) {
    return yield put(actions.failUpdate(id, "couldn't create endpoint"));
  }

  try {
    const updatedEntity: EntityWithId<T> = yield call([client, 'put'], `${endpoint}/${id}`, entity);
    return yield put(actions.completeUpdate(updatedEntity));
  } catch (error) {
    return yield put(actions.failUpdate(id, (error as Error).message));
  }
}

export function newUpdateSaga<T, S>(
  client: IClient<T>,
  endpointCreator: EndpointCreator,
  actions: IUpdateActions<T>,
  service: S,
) {
  const isUpdateRequest = (action: Action<T, S>) =>
    action.type === Types.UPDATE_REQUESTED && action.service === service;

  return function*() {
    yield takeEvery(isUpdateRequest as any, (action: RequestWithEntity<T, S>) =>
      update(client, endpointCreator, actions, action.payload.id, action.payload.entity, action.payload.params),
    );
  };
}
